import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginModule } from './login/login.module';
import { MatButtonModule } from "@angular/material/button";
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ConfigService } from './services/config.service';
import { HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { SharedModule } from "@rubii/frontend-common";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccountModule } from "./account/account.module";
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ActivateComponent } from './activate/activate.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AdvertiserModule } from './advertiser/advertiser.module';
import { RoleService } from './services/role.service';
import { ClientService } from './services/client.service';
import { MarkdownService } from './services/markdown.service';
import { LockModule } from './lock/lock.module';
import { VerificationModule } from './verification/verification.module';
import { VerificationService } from './services/verification.service';
import { CallbackComponent } from './callback/callback.component';
import { TestComponent } from './test/test.component';
@NgModule({
  declarations: [
    AppComponent,
    ActivateComponent,
    CallbackComponent,
    TestComponent,
  ],
  imports: [
    BrowserModule,
    MatProgressBarModule,
    MatGridListModule,
    MatIconModule,
    MatTooltipModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    FormsModule,
    MatButtonModule,
    LoginModule,
    HttpClientModule,
    MatSnackBarModule,
    SharedModule.forRoot(),
    AccountModule,
    AdvertiserModule,
    LockModule,
    VerificationModule
  ],
  providers: [
    ConfigService,
    ClientService,
    MarkdownService,
    { provide: 'accountHost', useValue: environment.accountRoot },
    { provide: 'frontendAccountHost', useValue: environment.frontendAccountHost },
    { provide: 'frontendReportHost', useValue: environment.frontendReportHost },
    { provide: 'frontendTrackerHost', useValue: environment.frontendTrackerHost },
    { provide: 'frontendReconcileHost', useValue: environment.frontendReconcileHost },
    { provide: 'frontendOrderHost', useValue: environment.frontendOrderHost },
    { provide: 'notificationRoot', useValue: environment.notificationRoot },
    { provide: 'reportRoot', useValue: environment.reportRoot },
    { provide: 'openaiRoot', useValue: environment.openaiRoot },
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher,
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 25000,
        verticalPosition: 'top',
        panelClass: 'snack',
      }
    },
    RoleService,
    VerificationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }